/* eslint-disable react/no-multi-comp */
/* eslint-disable react/jsx-max-props-per-line */
import React from 'react';
import PropTypes from 'prop-types';
import { Box, Stack, Typography } from '@mui/material';
import { DialogDefaultV2 } from '../../../components/v2';

const Section = ({ title, children }) => (
  <Stack spacing={0.75}>
    <Typography variant="body2">
      <strong>{title}</strong>
    </Typography>
    {children}
  </Stack>
);

Section.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

const bullets = (items) => (
  <Box
    component="ul"
    sx={{ m: 0, pl: 2.5 }}
  >
    {items.map((item) => (
      <Typography key={item} component="li" variant="body2">
        {item}
      </Typography>
    ))}
  </Box>
);

const ComoFuncionaDecisaoDialog = ({ open, onClose }) => (
  <DialogDefaultV2
    open={open}
    handlerCancel={onClose}
    handlerConfirm={onClose}
    title="Como funciona"
    maxWidth="md"
    fullWidth
    useFullScreen={false}
    readOnly
    zIndex={1400}
  >
    <Stack spacing={1.5}>
      <Typography variant="body2">
        Aqui você decide só o que vai acontecer com este item. O Confirmar pede uma confirmação com o que vai
        acontecer. Voltar descarta e não grava.
      </Typography>
      <Section title="Aprovar">
        {bullets([
          'O item passa a Aprovado: vamos atender com o que já existe no estoque.',
          'Se não houver saldo para a quantidade, Aprovar fica indisponível: impossível aprovar por falta de estoque.',
          'Para produto, na confirmação você escolhe o local de retirada (origem no estoque).',
          'Neste momento não criamos entrega. Só mudamos o status do item e gravamos a origem.',
          'Depois, na aba Entregas, use Criar entrega — só depois que não restar item Pendente na requisição. Marque este item (e outros Aprovado, se quiser o mesmo pacote), escolha o tipo (transportadora, colaborador ou retirada) e confirme.',
          'Enquanto o item não estiver numa entrega, você pode Alterar a decisão (estorna estoque ou cancela a compra, se ainda for possível).',
          'A primeira entrega criada passa a requisição para Executando.',
        ])}
      </Section>
      <Section title="Rejeitar">
        {bullets([
          'O item não será atendido. O motivo é obrigatório e o solicitante vê no app.',
          'Não criamos entrega nem pedido de compra.',
          'Se todos os itens da requisição forem rejeitados, a requisição fica Rejeitada.',
        ])}
      </Section>
      <Section title="Para pedido">
        {bullets([
          'O item será atendido por um pedido de almoxarifado — não usa o saldo atual.',
          'Você informa produto, local, quantidade e valores. Devolução de uso fica Não.',
          'Ao gravar, o pedido fica ligado a este item. Não há status de pedido.',
          'Depois disso o item já pode entrar numa entrega, do mesmo jeito que um Aprovado.',
        ])}
      </Section>
      <Section title="Status da requisição (depois desta decisão)">
        {bullets([
          'Aguardando enquanto houver qualquer item Pendente.',
          'Aprovada quando não restar Pendente, ainda houver o que atender, e ainda não existir entrega.',
          'Executando quando a primeira entrega for criada.',
          'Finalizada quando não faltar entrega nem pedido em aberto.',
          'Rejeitada se nenhum item for atendido.',
          'Cancelada quando cancelar a requisição inteira.',
        ])}
      </Section>
    </Stack>
  </DialogDefaultV2>
);

ComoFuncionaDecisaoDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

ComoFuncionaDecisaoDialog.defaultProps = {
  open: false,
};

export default ComoFuncionaDecisaoDialog;
